export default function RequiredMark() {
    return <span className="ml-0.5 text-destructive">*</span>;
}
